import {
  removeSelection,
  getSelectionKey
} from '../../PlanningEntityPicker.utils';
import PlanningEntityChip from '../PlanningEntityChip';

import type { PlanningEntitySelectionChipsProps } from './PlanningEntitySelectionChips.types';

/**
 * The picked people and plan units as chips, each with ✕. Rendered by the picker itself, or — with
 * `showSelection={false}` on the picker — by the page, where it groups its applied filters.
 */
const PlanningEntitySelectionChips = ({
  value,
  onChange
}: PlanningEntitySelectionChipsProps) => {
  'use memo';

  return (
    <>
      {value.map((selection) => (
        <PlanningEntityChip
          key={getSelectionKey(selection)}
          selection={selection}
          onRemove={(removed) => onChange(removeSelection(value, removed))}
        />
      ))}
    </>
  );
};

export default PlanningEntitySelectionChips;
